import { useTranslation } from 'react-i18next';

const badges = [
  { icon: 'ri-shield-check-fill', titleKey: 'trust1_title', subKey: 'trust1_sub' },
  { icon: 'ri-award-fill', titleKey: 'trust2_title', subKey: 'trust2_sub' },
  { icon: 'ri-leaf-fill', titleKey: 'trust3_title', subKey: 'trust3_sub' },
  { icon: 'ri-drop-fill', titleKey: 'trust4_title', subKey: 'trust4_sub' },
  { icon: 'ri-verified-badge-fill', titleKey: 'trust5_title', subKey: 'trust5_sub' },
  { icon: 'ri-star-s-fill', titleKey: 'trust6_title', subKey: 'trust6_sub' },
];

export default function TrustBadges() {
  const { t } = useTranslation();

  return (
    <section className="py-14 bg-white border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-6">
        <p className="text-center text-slate-400 text-sm font-semibold uppercase tracking-widest mb-10">
          {t('trust_label')}
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {badges.map((badge) => (
            <div
              key={badge.titleKey}
              className="flex flex-col items-center justify-center py-6 px-4 rounded-xl border border-slate-100 bg-slate-50 hover:border-sky-100 hover:bg-sky-50 transition-all duration-200"
            >
              <div className="w-10 h-10 flex items-center justify-center mb-3">
                <i className={`${badge.icon} text-sky-600 text-3xl`}></i>
              </div>
              <span className="text-slate-800 font-bold text-sm text-center">{t(badge.titleKey)}</span>
              <span className="text-slate-400 text-xs text-center mt-0.5">{t(badge.subKey)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
